import { createAction } from "@reduxjs/toolkit";

enum LayoutReducer {
	toggleSidebar = "[LAYOUT] Toggle Sidebar"
}

export const layoutToggleSidebar = createAction(LayoutReducer.toggleSidebar);